import React from 'react';
import { DetectionsCircularProgressBar } from 'lib/cortiAnalyticsUI';
import { Base, Typography } from 'lib/cortiUI';
export const CallTakersMetricsBreakdownItem = ({ title, value, target, }) => {
    return (React.createElement(Base, { display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: 8 },
        React.createElement(Typography, { color: "default", variant: "subtitle1" }, title),
        React.createElement(DetectionsCircularProgressBar, { value: value, target: target, size: 24, strokeWidth: 4, label: `${Math.round((value !== null && value !== void 0 ? value : 0) * 100)}%` })));
};
